'use client';

import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';

import AndyAvatar from '@/assets/images/members/andy.png';
import AngelAvatar from '@/assets/images/members/angel.png';
import BenAvatar from '@/assets/images/members/ben.png';
import GunsanAvatar from '@/assets/images/members/gunsan.png';
import KevinAvatar from '@/assets/images/members/kevin.png';
import ENlightenLogo from '@/assets/images/members/logo.png';
import NamsanAvatar from '@/assets/images/members/namsan.png';
import ApartmentBackground from '@/assets/images/pages/home/drawer/apartment.jpg';
import BizFinanceBackground from '@/assets/images/pages/home/drawer/bizfinance.jpg';
import BizkingBackground from '@/assets/images/pages/home/drawer/bizking.jpg';
import FinanceBackground from '@/assets/images/pages/home/drawer/finance.jpg';
import FsBackground from '@/assets/images/pages/home/drawer/fs.jpg';
import HouseBackground from '@/assets/images/pages/home/drawer/house.jpg';
import InsightBackground from '@/assets/images/pages/home/drawer/insight.jpg';
import LoanBackground from '@/assets/images/pages/home/drawer/loan.jpg';
import ProductBackground from '@/assets/images/pages/home/drawer/product.jpg';
import Re100Background from '@/assets/images/pages/home/drawer/re100.jpg';
import RooftopBackground from '@/assets/images/pages/home/drawer/rooftop.jpg';

import Business from './Business';
import Owner from './Owner';
import Prepare from './Prepare';
import TutorialGridTemplate from './TutorialGridTemplate';

export interface ITutorialStepComponent {
	onChangeComponent: Dispatch<SetStateAction<'prepare' | 'business' | 'start' | 'house' | 'news' | 'owner' | 're100' | 'product'>>;
}

export default function TutorialSteps() {
	const [componentName, setComponentName] = useState<'prepare' | 'business' | 'start' | 'house' | 'news' | 'owner' | 're100' | 'product'>('prepare');

	switch (componentName) {
		case 'business':
			return <Business onChangeComponent={setComponentName} />;
		case 'start':
			return (
				<TutorialGridTemplate
					title={'전문가와 함께\n태양광을 시작해보세요'}
					list={[
						{
							background: FsBackground,
							avatar: NamsanAvatar,
							title: '사업부지 검토',
							subTitle: '사업 가능 여부 무료로 확인하기',
							comment: '"사업지 주소만 입력해 주시면 꼼꼼하게 검토해드립니다"',
							linkProps: {
								href: '/fs',
							},
						},
						{
							background: FinanceBackground,
							avatar: AndyAvatar,
							title: '금융 자문',
							subTitle: '태양광 업계 최고 금융 실적',
							comment: '"건설 자금이 부족해도 걱정 마세요! 최고의 금융팀이 해결해드립니다"',
							linkProps: {
								href: '/finance',
							},
						},
						{
							background: RooftopBackground,
							avatar: GunsanAvatar,
							title: '공장 지붕 태양광',
							subTitle: '최대 6억 8천만원 임대 수익!',
							comment: '"비어있는 공장 지붕에서 20년간 고정 수익 창출하세요"',
							linkProps: {
								href: '/rooftop',
							},
						},
					]}
					onChangeComponent={setComponentName}
				/>
			);
		case 'house':
			return (
				<TutorialGridTemplate
					title={'우리 집에 태양광을\n설치해보세요'}
					list={[
						{
							background: HouseBackground,
							avatar: AngelAvatar,
							title: '주택용 태양광',
							subTitle: '우리 집 전기료 80% 절감',
							comment: '"타사 대비 40만원 추가 할인받고 최저가로 설치하세요"',
							linkProps: {
								href: '/house',
							},
						},
						{
							background: ApartmentBackground,
							avatar: AngelAvatar,
							title: '아파트 태양광',
							subTitle: '친환경으로 관리비 절감',
							comment: '"한국에너지공단 선정 공식 사업자에게 믿고 맡기세요"',
							linkProps: {
								href: '/apartment',
							},
						},
					]}
					onChangeComponent={setComponentName}
				/>
			);
		case 'news':
			return (
				<TutorialGridTemplate
					title={'전문가가 엄선한\n소식을 받아보세요'}
					list={[
						{
							background: InsightBackground,
							avatar: ENlightenLogo,
							title: '인사이트',
							subTitle: '하루도 놓치면 안 될 에너지 소식',
							comment: '"에너지 비즈니스에 도움을 드리는 유용한 지식을 전달합니다"',
							linkProps: {
								href: '/insight',
							},
						},
					]}
					onChangeComponent={setComponentName}
				/>
			);
		case 'owner':
			return <Owner onChangeComponent={setComponentName} />;
		case 're100':
			return (
				<TutorialGridTemplate
					title={'글로벌 수준의\n사업을 시작해보세요'}
					list={[
						{
							background: InsightBackground,
							avatar: ENlightenLogo,
							title: '인사이트',
							subTitle: '하루도 놓치면 안 될 에너지 소식',
							comment: '"에너지 비즈니스에 도움을 드리는 유용한 지식을 전달합니다"',
							linkProps: {
								href: '/insight',
							},
						},
						{
							background: Re100Background,
							avatar: KevinAvatar,
							title: 'RE100',
							subTitle: '국내 최초 RE100 공식 이행 계약 체결',
							comment: '"국내 최고 RE100 전문가와 함께 지속가능한 발전을 실현하세요"',
							linkProps: {
								href: '/trading',
							},
						},
					]}
					onChangeComponent={setComponentName}
				/>
			);
		case 'product':
			return (
				<TutorialGridTemplate
					title={'금융, IT 솔루션으로\n수익을 극대화하세요'}
					list={[
						{
							background: BizFinanceBackground,
							avatar: AndyAvatar,
							title: '기업 금융',
							subTitle: '업계 1위 태양광 금융',
							comment: '"사업별 특성을 고려한 맞춤 금융 솔루션을 제공합니다"',
							linkProps: {
								href: '/bizfinance',
							},
						},
						{
							background: BizkingBackground,
							avatar: BenAvatar,
							title: '발전왕 비즈',
							subTitle: '모든 발전소 한번에 모니터링',
							comment: '"장비 교체 없이 로그인 한번으로 통합 모니터링 하세요"',
							linkProps: {
								href: '/bizking',
							},
						},
						{
							background: LoanBackground,
							avatar: AndyAvatar,
							title: '시공비 100% 여신',
							subTitle: '최대 9억원까지 시공비 선지급',
							comment: '"담보, 보증 부담을 최소화로 현금 확보 부담을 없애드립니다"',
							linkProps: {
								href: '/loan',
							},
						},
						{
							background: ProductBackground,
							avatar: AndyAvatar,
							title: '기자재 특가·여신',
							subTitle: '업계 최저가 기자재 구매',
							comment: '"거래실적과 관계없이 전 시공사 여신이 가능합니다"',
							linkProps: {
								href: '/product',
							},
						},
					]}
					onChangeComponent={setComponentName}
				/>
			);
		default:
			return <Prepare onChangeComponent={setComponentName} />;
	}
}
